import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogData } from '@greco-fit/scaffolding';
import { EventVideo, EventVideoUnlock } from '@greco/event-videos';
import { VideoTagService } from '@greco/ngx-videos';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';
import { EventVideoUnlockService } from '../../services';

@Component({
  templateUrl: './manage-unlock.dialog.html',
  styleUrls: ['./manage-unlock.dialog.scss'],
})
export class ManageUnlockDialog implements OnInit, OnDestroy {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { communityId: string },
    private unlockSvc: EventVideoUnlockService,
    private formBuilder: FormBuilder,
    private snacks: MatSnackBar,
    private matDialog: MatDialog,
    private tagSvc: VideoTagService,
    private matDialogRef: MatDialogRef<ManageUnlockDialog>
  ) {}

  eventVideo!: EventVideo;
  updateUnlock!: EventVideoUnlock;

  private _onDestroy$ = new Subject<void>();

  selectable = true;
  removable = true;

  _creating = false;

  formGroup = this.formBuilder.group({
    userEmail: ['', Validators.required],
    expiryDate: [null],
  });

  now = new Date();
  dialogData: DialogData = {
    title: 'Manage Event Video Unlock',
    //subtitle: 'Grant or update unlock to user',
    showCloseButton: false,
    buttons: [
      { label: 'Cancel', role: 'cancel' },
      {
        label: 'Save',
        role: 'create',
        resultFn: async () => {
          try {
            const data = this.formGroup.value;
            this._creating = true;
            try {
              if (!this.updateUnlock) {
                if (data.expiryDate && data.expiryDate.getTime() < Date.now()) {
                  this.snacks.open('Selected date is in the past! Please try again.', 'Ok', {
                    duration: 3500,
                    panelClass: 'mat-warn',
                  });
                } else {
                  const unlock = await this.unlockSvc.adminGrantEventVideoToUser(
                    data.userEmail,
                    this.eventVideo.id,
                    data.expiryDate
                  );
                  if (!unlock) {
                    this.snacks.open('User already has base video unlocked', 'Ok', {
                      duration: 3500,
                      panelClass: 'mat-warn',
                    });
                  } else {
                    this.snacks.open('Granted replay to ' + unlock.user?.displayName, 'Ok', {
                      duration: 3500,
                      panelClass: 'mat-primary',
                    });
                  }

                  this.matDialogRef.close(unlock);
                }
              } else {
                const unlock = await this.unlockSvc.updateUnlockTime(this.updateUnlock.id, data.expiryDate);
                this.snacks.open('Expiry time set to: ' + data.expiryDate, 'Ok', {
                  duration: 3500,
                  panelClass: 'mat-primary',
                });
                this.matDialogRef.close(unlock);
              }
            } catch (err) {
              console.error(err);
              this.snacks.open('Something went wrong. Please try again!', 'Ok', {
                duration: 5000,
                panelClass: 'mat-warn',
              });
            }

            this._creating = false;
          } catch (err) {
            console.error(err);
            return null;
          }
        },
      },
    ],
  };

  async ngOnInit() {
    this.formGroup.valueChanges.pipe(startWith(this.formGroup.value), takeUntil(this._onDestroy$)).subscribe(() => {
      this.dialogData = {
        ...this.dialogData,
        buttons: this.dialogData.buttons?.map(btn => {
          if (btn.role === 'create') btn.disabled = this.formGroup.invalid;
          return btn;
        }),
      };
    });
    if (this.updateUnlock)
      this.formGroup.setValue(
        { userEmail: this.updateUnlock.user?.contactEmail, expiryDate: this.updateUnlock.expiresOn },
        { emitEvent: true }
      );
  }

  ngOnDestroy() {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }
}
